var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasvalidate(_vm.field)
    ? _c("div", [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(_vm._s(_vm.field.title) + "  ")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "list-inline" },
          _vm._l(_vm.field.options, function(option, key) {
            return _c(
              "li",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: key },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  },
                  [_vm._v(" " + _vm._s(option) + " ")]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }